/**
 * ValidationsStep.jsx
 * ===================
 * Validation configuration for setup wizard
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import SetupWizard from './SetupWizard';
import ValidationsPage from '../Validations/ValidationsPage';

const ValidationsStep = () => {
  const { appName } = useParams();

  return (
    <SetupWizard currentStepKey="validations">
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        border: '1px solid #E5E7EB',
        padding: '32px',
        marginBottom: '20px'
      }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#111827',
          marginBottom: '8px'
        }}>
          ✅ Add Validations
        </h2>
        <p style={{
          fontSize: '14px',
          color: '#6B7280',
          marginBottom: '24px'
        }}>
          Make your forms smart with validation rules and conditional logic.
        </p>

        <div style={{
          padding: '24px',
          backgroundColor: '#F9FAFB',
          borderRadius: '8px',
          marginBottom: '24px'
        }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#111827',
            marginBottom: '12px'
          }}>
            💡 Quick Tips:
          </h3>
          <ul style={{
            fontSize: '14px',
            color: '#6B7280',
            margin: 0,
            paddingLeft: '20px'
          }}>
            <li>Add required field validations to your forms</li>
            <li>Create conditional rules (show/hide fields)</li>
            <li>Set up business rules for complex logic</li>
            <li>Skip this step if your app doesn't have forms</li>
          </ul>
        </div>
      </div>

      {/* Embed ValidationsPage */}
      <ValidationsPage appName={appName} />
    </SetupWizard>
  );
};

export default ValidationsStep;
























